module.exports = __webpack_public_path__ + "img/fashion_104.d7b71fe0.jpg";